import React from 'react'

import SliderSection from '@components/Content/Slider/SliderSection'
import SectionTitle from '@components/Section/SectionTitle'

import { StyledTitleType } from '@contracts/Components/StyledTitle'

import * as styles from './ExternalArticlesSection.module.scss'
import ExternalArticlesSlider from './ExternalArticlesSlider'

const ExternalArticlesSection = () => {
	const sectionTitle: StyledTitleType = [
		{
			styledText: {
				text: 'In the <em>media</em>',
				isYellow: false,
				isThin: false,
				isSplit: false,
			},
		},
	]

	const title = <SectionTitle title={sectionTitle} />
	const slider = <ExternalArticlesSlider />

	return <SliderSection title={title} slider={slider} sectionClassName={styles.section} />
}

export default ExternalArticlesSection
